export const homeHero = {
  lightBg: true,
  lightText: false,
  lightTextDesc: true,
  topLine: "A helping hand, makes a great gathering !",
  headline: "Meals Preparation, Fun and Stress Free",
  description:
    "Bring friends together, to cook delicious meals for your next office hangout, an ailing friend or a birthday party",
  buttonLabel: "Get Started",
  imgStart: "",
  img: "images/burger.png",
  alt: "burger-pizza",
};
